<template>
  <div>
    <section class="parallax-section" data-scrollax-parent="true" id="sec1">
      <parallax
        class="bg par-elem"
        v-bind:style="{
          'background-image':
            'url(' + myTheme.home_section_background_image + ')'
        }"
      ></parallax>
      <div class="overlay"></div>
      <div class="container">
        <div class="section-title center-align">
          <h1 class="head-sec-title"><span>Contact</span></h1>
          <div class="breadcrumbs fl-wrap ">
            <router-link class="breadcrumb-link breadcrumb-home" to="/">
              {{ $t('text.home') }}
            </router-link>
            <span class="breadcrumb-current" title="Contact">{{ $t('text.contact_us') }}</span>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row location-information">
          <div class="col-md-6 left-column">
            <location-infos></location-infos>
          </div>
          <div class="col-md-6 right-column">
            <map-viewer v-if="selectedLocation" ></map-viewer>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { Parallax } from "@/components";
import { helpers } from "@/utilities";
import {MapViewer, LocationInfos} from '@/views/components'

export default {
  name:'contact-us',
  components: {
    Parallax,
    MapViewer,
    LocationInfos
  },
  data() {
    return {
      getHelpers: helpers,
      isMounted : false
    };
  },
  mounted(){
    this.isMounted = true;
  }

};
</script>
